<template>
	<div class="textfilter">
		<h6>{{title}}</h6>
		<div class="input" style="white-space:nowrap">
			<input class="searchresult" :value="value" @input="$emit('input', $event.target.value)" type="hidden" >
			<input class="searchtext" placeholder="Search here.." v-model="filtertext" type="text" :readonly="readonly" >
			<input type="button" class="searchreset" value="Clear" @click="clearselect()" >
		</div>
		<div class="result">
			<ul class="flex m-0 p-0">
				<li v-for="(i,idx) in filterresult" :key="idx" v-show="value==''" >
				<div @click="filterselect(i)">
					{{i[fldinfo]}}
				</div>
				</li>
			</ul>                    
		</div>
	</div>
</template>

<script>

export default
{
	props:["title", "options", "fldid", "fldinfo", "value"],
	components:
	{
	},
	computed:
	{
	},
	data() 
	{
		return {
			filtertext:'',
			filterresult:[],
			readonly:false,
		}
	},
	watch:
	{
		filtertext(now,before)
		{
			if (!now) {
				this.filterresult = []
			}
			else if(now !== before) {
				if (this.options) {
					this.filterresult = this.options.filter(e=>{return e[this.fldinfo].toLowerCase().indexOf(now.toLowerCase())>-1})
				}
				if (!this.value && this.filterresult.length == 1) this.filterselect(this.filterresult[0])
			}
		},
	},      
	mounted()
	{
	},
	methods:
	{
		
		clearselect() {
			this.filtertext = ''
			var inp = document.querySelector('.textfilter .input .searchresult')
			inp.value = ''
			this.$emit('input', inp.value)
			this.readonly = false
		},
		
		filterselect(selected){
			this.filtertext = selected[this.fldinfo]
			var inp = document.querySelector('.textfilter .input .searchresult')
			inp.value = selected[this.fldid]
			this.$emit('input', inp.value)
			this.readonly = true
		},
	}
}
</script>
<style>

.textfilter .input .searchtext { width:90%; }
.textfilter .result { margin: 0px 0px 0px; width: 100%; border-radius: 5px; padding:0px;    }
.textfilter .result ul{ z-index:1000; background: white; position:absolute; list-style-type: none; border-radius: 10px; margin-bottom: 10px; overflow-y: scroll; overflow-x: hidden; max-height:220px; width:90%;}
.textfilter .result ul li{ padding:5px 10px;  white-space:nowrap; cursor: pointer;}

</style>